var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrCloudClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 115,
    viewBox: "0 0 148 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.2262 11.2663C34.2902 3.56233 46.6022 -0.505673 59.2742 0.250327C72.0902 1.00633 84.9782 9.71832 100.494 24.0103C128.862 50.1823 153.774 61.0903 145.53 83.0863C137.286 105.082 94.0862 120.274 64.7462 111.778C35.4422 103.282 4.55423 76.6063 9.84623 43.5583C12.3302 28.0423 19.4222 17.7823 26.2262 11.2663Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.79481 65.4823C11.6122 65.4823 14.7068 62.3877 14.7068 58.5703C14.7068 54.7529 11.6122 51.6583 7.79481 51.6583C3.97742 51.6583 0.882812 54.7529 0.882812 58.5703C0.882812 62.3877 3.97742 65.4823 7.79481 65.4823Z",
    fill: "url(#paint0_linear_11098_3921)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.673 35.9624C130.606 35.9624 137.037 29.5314 137.037 21.5984C137.037 13.6654 130.606 7.23438 122.673 7.23438C114.74 7.23438 108.309 13.6654 108.309 21.5984C108.309 29.5314 114.74 35.9624 122.673 35.9624Z",
    fill: "url(#paint1_linear_11098_3921)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M126.233 113.83C128.142 113.83 129.689 112.283 129.689 110.374C129.689 108.466 128.142 106.918 126.233 106.918C124.325 106.918 122.777 108.466 122.777 110.374C122.777 112.283 124.325 113.83 126.233 113.83Z",
    fill: "url(#paint2_linear_11098_3921)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M75.437 90.8623C96.4128 90.8623 113.417 73.8581 113.417 52.8823C113.417 31.9066 96.4128 14.9023 75.437 14.9023C54.4613 14.9023 37.457 31.9066 37.457 52.8823C37.457 73.8581 54.4613 90.8623 75.437 90.8623Z",
    fill: "url(#paint3_linear_11098_3921)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3731 33.1903H71.6211V58.1023L81.8811 68.3623L85.1931 65.0503L76.3731 56.2303V33.1903Z",
    fill: "#7F8087"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9979 95.3264C52.9019 95.3264 35.8379 78.2624 35.8379 57.1664C35.8379 36.0704 52.9019 19.0064 73.9979 19.0064C95.0939 19.0064 112.158 36.1784 112.158 57.1664C112.158 78.2624 95.0939 95.3264 73.9979 95.3264ZM73.9979 14.2544C50.3819 14.2544 31.0859 33.4424 31.0859 57.1664C31.0859 80.8904 50.3819 100.078 73.9979 100.078C97.7219 100.078 116.91 80.8904 116.91 57.1664C116.91 33.4424 97.6139 14.2544 73.9979 14.2544Z",
    fill: "#7F8087"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11098_3921",
    x1: 0.863336,
    y1: 58.578,
    x2: 14.7175,
    y2: 58.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0025835,
    stopColor: "#CDD0D3",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8087",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11098_3921",
    x1: 108.33,
    y1: 21.6104,
    x2: 137.028,
    y2: 21.6104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0025835,
    stopColor: "#CDD0D3",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8087",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11098_3921",
    x1: 122.772,
    y1: 110.359,
    x2: 129.699,
    y2: 110.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0025835,
    stopColor: "#CDD0D3",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8087",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11098_3921",
    x1: 37.443,
    y1: 52.8874,
    x2: 113.403,
    y2: 52.8874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F8087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD0D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrCloudClock);
export default __webpack_public_path__ + "static/media/ubr-cloud-clock.19d9c798a67f4d0cad595921cdcec781.svg";
export { ForwardRef as ReactComponent };